import { render, staticRenderFns } from "./SpSideBar.vue?vue&type=template&id=ebed4124&scoped=true&"
import script from "./SpSideBar.vue?vue&type=script&lang=ts&"
export * from "./SpSideBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebed4124",
  null
  
)

export default component.exports